
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/best-certificate-lifecycle-management",
      function () {
        return require("private-next-pages/compare/best-certificate-lifecycle-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/best-certificate-lifecycle-management"])
      });
    }
  